export const ConsentPurposes = {
    'required': 1,
    'functional': 2,
    'measurement': 4
} as const;

export type ConsentKey = typeof ConsentPurposes[keyof typeof ConsentPurposes];
